module.exports = __webpack_public_path__ + "img/hp/hp-og-1200x630.8bf2abcd735a8d4a1f7725538f1f2d73.jpg";